
<style lang="scss" scoped>
  input {
    &::placeholder {
      color: rgba($color: #828393, $alpha: 0.6);
    }
  }
  .bind-alipay-page {
    background-color: #f8f8fb;
    min-height: 100vh;
    .bind-title {
      height: 86px;
      font-size: 26px;
      color: #828393;
      padding-left: 32px;
      display: flex;
      align-items: center;
    }
    .bind-form {
      p {
        box-sizing: border-box;
        width: 750px;
        height: 110px;
        line-height: 110px;
        font-size: 30px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
        .label {
          display: inline-block;
          // width: 180px;
          font-weight: 500;
          letter-spacing: 10px;
          text-align: right;
          color: #1d1d1d;
          padding-left: 32px;
        }
        input {
          height: 100%;
          width: 500px;
          text-indent: 0;
          background: transparent;
          border: 0 none;
          resize: none;
          outline: none;
          -webkit-appearance: none;
          padding-left: 44px;
          color: #999;
          font-size: 28px;
          line-height: normal;
          vertical-align: unset;
        }
      }
    }
  }
  .bind-submit {
    width: 686px;
    height: 88px;
    margin: 64px auto;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 34px;
    color: #fff;
    background-color: #2A2A30;
  }
  .bind-submit-gray {
    background-color: rgba(231, 231, 240, 0.6);
    color: #fff;
  }
  .bind-submit-black {
  }
  .confirm-alert {
    position: fixed;
    top: 288px;
    left: 50%;
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
    background-color: #fff;
    width: 620px;
    border-radius: 16px;
    font-size: 16px;
    -webkit-user-select: none;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    z-index: 2001;
    .confirm-title {
      // height: 154px;
      padding: 32px;
      // line-height: 112px;
      font-size: 34px;
      color: #fff;
      text-align: center;
      // background-color: #1d1d1d;
      background: linear-gradient(90deg, #FF5572 0%, #FF6ABB 100%);
      .title {
        font-size: 34px;
        color: #fff;
        text-align: center;
        font-weight: 500;
        line-height: 48px;
      }
      .confirm-warning {
        margin-top: 8px;
        font-size: 24px;
        line-height: 34px;
        color: rgba($color: #fff, $alpha: 0.7);
        // margin-bottom: 16px;
        text-align: center;
      }
    }
    .confirm-msg {
      height: 400px;
      padding: 50px 0 98px;
      vertical-align: middle;
      .msg-title {
        // margin-top: 40px;
        font-size: 24px;
        line-height: 34px;
        color: #828393;
        text-align: center;
        &.name {
          margin-top: 44px;
        }
      }
      .msg-value {
        font-size: 34px;
        line-height: 48px;
        color: #2A2A30;
        margin-top: 16px;
        text-align: center;
      }
    }

    .confirm-btns {
      box-sizing: border-box;
      display: flex;
      height: 114px;
      line-height: 114px;
      border-top: 1px solid #F1F1F6;
      .confirm-btn {
        font-size: 34px;
        font-weight: 500;
        line-height: 114px;
        display: block;
        background-color: #fff;
        flex: 1;
        margin: 0;
        border: 0;
      }
      .btn-cancel {
        width: 50%;
        color: #828393;
        border-right: 1px solid #F1F1F6;
      }
      .btn-confirm {
        color: #FF5572;
        width: 50%;
      }
    }
  }
  .alert-mark {
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 2000;
  }
</style>

<template>
  <div class="bind-alipay-page">
    <div class="bind-title">
      支付宝收款账号
    </div>
    <div class="bind-form">
      <p><span class="label">账号</span><input maxlength="100" v-model="alipayAccount" v-hasValue placeholder="支付宝账号"></p>
      <p><span class="label">姓名</span><input maxlength="10" v-model="name" v-hasValue placeholder="请输入姓名"></p>
    </div>
    <div v-bind:class="canSubmit ? 'bind-submit bind-submit-black' : 'bind-submit bind-submit-gray'" @click="submitChange()">
      <span>完成</span>
    </div>
    <div v-if="showConfirm">
      <div class="confirm-alert">
        <div class="confirm-title">
          <p class="title">请确认您的收款支付宝账号</p>
          <p class="confirm-warning">
            为保证收款顺利，请再次确认您的支付宝账号！
          </p>
        </div>
        <div class="confirm-msg">
          <p class="msg-title">支付宝账号</p>
          <p class="msg-value">{{alipayAccount}}</p>
          <p class="msg-title name">姓名</p>
          <p class="msg-value">{{name}}</p>
        </div>

        <div class="confirm-btns">
          <button class="confirm-btn btn-cancel" @click="submitChange()">返回修改</button>
          <button class="confirm-btn btn-confirm" @click="submitConfirm()">确认无误</button>
        </div>
      </div>
      <div class="alert-mark"></div>
    </div>
  </div>
</template>

<script>
import { walletBoundAlipay } from '../../common/api/wallet'
import { Indicator } from 'mint-ui'

export default {
  name: 'bindAlipay',

  data () {
    return {
      alipayAccount: '',
      name: '',
      showConfirm: false
    }
  },

  methods: {
    submitChange () {
      if (this.canSubmit) {
        this.showConfirm = !this.showConfirm
      }
    },
    submitConfirm () {
      Indicator.open({
        text: '绑定中...',
        spinnerType: 'fading-circle'
      })
      walletBoundAlipay({ alipayAccount: this.alipayAccount, name: this.name })
        .then(result => {
          if (result.errorCode === 0) {
            this.$router.replace({ name: 'bindAlipaySuccess' })
          } else {
            this.showConfirm = false
          }
        }).finally(() => {
          Indicator.close()
        })
    }
  },

  computed: {
    canSubmit () {
      return this.alipayAccount !== '' && this.name !== ''
    },
  },

  directives: {
    hasValue: {
      update: function (el, value) {
        if (value === '') {
          el.style.color = '#999'
        } else {
          el.style.color = '#1D1D1D'
        }
      }
    }
  }
}
</script>
